export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_SEND_DEVICE_ID = 'USER_SEND_DEVICE_ID'
export const USER_LOG_ACTION = 'USER_LOG_ACTION'